import { Tooltip } from '@material-ui/core';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import BallotIcon from '@material-ui/icons/Ballot';
import BarChart from '@material-ui/icons/BarChart';
import DescriptionIcon from '@material-ui/icons/Description';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import Edit from '@material-ui/icons/Edit';
import LocationCityIcon from '@material-ui/icons/LocationCity';
import PeopleIcon from '@material-ui/icons/People';
import PlaceIcon from '@material-ui/icons/Place';
import * as React from 'react';
import ActionItems from './actionItems/ActionItems';
import AffinityClusters from './affinityClusters/AffinityClusters';
import AssessmentDashboard from './assessmentDashboard/AssessmentDashboard';
import Assessments from './assessments/Assessments';
import BestPractices from './bestPractices/BestPractices';
import Branches from './branches/Branches';
import ChevronEditor from './chevrons/ChevronEditor';
import Constants from './config';
import ExecutiveDashboard from './executiveDashboard/ExecutiveDashboard';
import Kpis from './kpis/Kpis';
import Login from './login/Login';
import Regions from './regions/Regions';
import { IRoute } from './routing';
import Users from './users/Users';

interface INavigationSection {
    header?: string;
    navigationRoutes: INavigationRoute[];
}

interface INavigationRoute extends IRoute {
    icon: React.ReactElement<SvgIconProps>;
    text: string;
    navigationLink?: string;
}

const routes: IRoute[] = [
    {
        component: () => <Login />,
        path: '/login',
    },
    {
        component: ChevronEditor,
        path: '/chevroneditor/:assessmentId?',
    },
    {
        component: AffinityClusters,
        path: '/affinityClusters/:assessmentId',
    },
    {
        component: AssessmentDashboard,
        path: '/assessmentDashboard/:assessmentId',
    },
];

const iconStyle: React.CSSProperties = {
    fill: 'white',
};

const navigationSectionWithHeader: INavigationSection = {
    header: 'Navigation',
    navigationRoutes: [
        {
            allowedRoles: [
                Constants.Roles.Administrator,
                Constants.Roles.OrganizationAdministrator,
            ],
            component: () => <Users />,
            icon: (
                <Tooltip title="Users">
                    <PeopleIcon style={iconStyle} />
                </Tooltip>
            ),
            path: '/users',
            text: 'Users',
        },
        {
            component: () => <Assessments />,
            icon: (
                <Tooltip title="Assessments">
                    <BallotIcon style={iconStyle} />
                </Tooltip>
            ),
            path: '/assessments',
            text: 'Assessments',
        },
        {
            component: ExecutiveDashboard,
            icon: (
                <Tooltip title="Executive Dashboard">
                    <BallotIcon style={iconStyle} />
                </Tooltip>
            ),
            path: '/executiveDashboard',
            text: 'Executive Dashboard',
        },
        {
            component: () => <Branches />,
            icon: (
                <Tooltip title="Branches">
                    <LocationCityIcon style={iconStyle} />
                </Tooltip>
            ),
            path: '/branches',
            text: 'Branches',
        },
        {
            component: () => <Regions />,
            icon: (
                <Tooltip title="Regions">
                    <PlaceIcon style={iconStyle} />
                </Tooltip>
            ),
            path: '/regions',
            text: 'Regions',
        },
        {
            component: () => <Kpis />,
            icon: (
                <Tooltip title="KPI's">
                    <BarChart style={iconStyle} />
                </Tooltip>
            ),
            path: '/kpis',
            text: "KPI's",
        },
        {
            component: () => <BestPractices />,
            icon: (
                <Tooltip title="Best Practices">
                    <DescriptionIcon style={iconStyle} />
                </Tooltip>
            ),
            path: '/bestpractices',
            text: 'Best Practices',
        },
        {
            component: () => <ActionItems />,
            icon: (
                <Tooltip title="Actions">
                    <DoneAllIcon style={iconStyle} />
                </Tooltip>
            ),
            path: '/actionitems',
            text: 'Actions',
        },
        {
            allowedRoles: [Constants.Roles.Administrator],
            component: ChevronEditor,
            icon: (
                <Tooltip title="Chevron Editor">
                    <Edit style={iconStyle} />
                </Tooltip>
            ),
            navigationLink: '/adminchevroneditor',
            path: '/adminchevroneditor/',
            text: 'Chevron Editor',
        },
        // DO NOT REMOVE -- USED FOR CODE GENERATION
    ],
};

const navigationSections: INavigationSection[] = [navigationSectionWithHeader];

let allRoutes = routes;
navigationSections.forEach((section) => {
    allRoutes = allRoutes.concat(section.navigationRoutes);
});

export default allRoutes;
export { INavigationRoute, INavigationSection, navigationSections };



// WEBPACK FOOTER //
// ./src/Routes.tsx